export default __webpack_public_path__ + "static/media/Emojis18.4366d404.png";